import { clientManagementUrl } from "./client";
import { officeLocationUrl } from "./officeLocation";
import { userManagementUrl } from "./userManagement";

export class SUITE {
    static readonly CLIENT_MANAGEMENT = new clientManagementUrl();
    static readonly OFFICE_LOCATION = new officeLocationUrl();
    static readonly USER_MANAGEMENT = new userManagementUrl();
}